export default __webpack_public_path__ + "static/media/icon-card-ai.b6cd8d0f.svg";